import { http } from 'services/http';
import { CLIENT_USERS_GET_MANY } from 'api/query-keys';
import type { TClientUserRes, TCreateClientUserReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useCreateClientUser = () => {
  return useMutationBase<TClientUserRes, unknown, TCreateClientUserReq>({
    mutationFn: async (variables) => {
      const res = await http.post('/v1/client-user', variables);

      return res.data;
    },

    invalidateCallback: ({ clientId }) => [[CLIENT_USERS_GET_MANY, clientId]],
  });
};
